module.exports = __webpack_public_path__ + "static/media/ZEREPORTES.215fef3f.png";